module.exports = __webpack_public_path__ + "img/title.2402de3b.png";